import React, { useState, useEffect } from 'react';
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { BiMessageRounded, BiMessageRoundedDots } from "react-icons/bi";
import { HiXMark } from "react-icons/hi2";


import { useLocation } from 'react-router-dom';
import { EUserType } from '../../data_models/enums';

import useRouting, { EProjectDetailsNav } from '../../hooks/useRouting';

import { BRAND_ASSETS, DEFAULT_USER_PROFILE } from '../../config/defaultAssetUrls';

import useCurrentUser from '../../hooks/useCurrentUser';

import { BROWSE_FREELANCERS_ROUTE, CHAT_ROUTE, DASHBOARD_ROUTE, ENGAGEMENTS_ROUTE, JOBS_ROUTE, PROJECT_DETAILS_ROUTE, PROJECTS_ROUTE, ROUTE_TITLE_MAP, SIGNUP_UPDATE_PROFILE_ROUTE } from '../../App';
import useChat from '../../hooks/useChat';
import { FiPlus } from 'react-icons/fi';
import { RxHamburgerMenu } from 'react-icons/rx';
import NavbarLink from './NavbarLink';
import { FilledButton, OutlinedButton, TextButton } from '../common/Button';
import IconButton from '../common/IconButton';
import { CiUser } from 'react-icons/ci';
import useAuth from '../../hooks/useAuth';
import { IoMdLogOut } from 'react-icons/io';
import MobileMenueButton from './MobileMenuButton';
import { getEmployerName } from '../../utils/employerUtils';
import { IEmployer } from '../../data_models/employer';
import { getFreelancerName } from '../../utils/freelancerUtils';
import { IFreelancer } from '../../data_models/freelancer';
import MobileMenuButton from './MobileMenuButton';
import useArielle from '../../hooks/useArielle';
import { EArielleProcessingType } from '../../data_models/aiModels/enums';
import useConfig from '../../hooks/useConfig';
import { EmployerWallet } from '../../data_models/employerWallet';
import { IoChatbubbleEllipsesOutline, IoChatbubbleOutline } from 'react-icons/io5';
import { FreelancerWallet } from '../../data_models/freelancerWallet';
import Tooltip from '../common/Tooltip';



const Navbar: React.FC = () => {
  const location = useLocation();
  const { logout } = useAuth()
  const { unselectActiveChat, totalNumberUnreadMessages } = useChat();
  const { currentUser, currentUserType, isLoggedIn, wallet } = useCurrentUser();
  const { goToBrowseFreelancers,
    goToCreateNewProject,
    goToEngagements,
    goToMyProjects,
    goToDashboard,
    goToJobs,
    goToChat,
    goToUserProfile,
    goToLogin,
    goToSignup,
    goToProjectDetails } = useRouting();
  const { config } = useConfig();

  const { renderArielleCreatingRoadmapNotification,
    renderArielleCreatingProjectDetailsNotification,
    lastReceivedProjectRoadmap,
    lastReceivedProjectDetails,
    isProcessing } = useArielle();

  const [ignoreRoadmapFeedbackTimestamps, setIgnoreRoadmapFeedbackTimestamps] = useState<number[]>([]);
  const [ignoreProjectDetailsFeedbackTimestamps, setIgnoreProjectDetailsFeedbackTimestamps] = useState<number[]>([]);

  useEffect(() => {
    // show roadmap feedback
    if (isProcessing.has(EArielleProcessingType.CREATE_PROJECT_ROADMAP) || lastReceivedProjectRoadmap) {
      !ignoreRoadmapFeedbackTimestamps.includes(lastReceivedProjectRoadmap?.timestamp!)
        && setShowAgentFeedbackRoadmap(true);
    }

    // show project details feedback
    if (isProcessing.has(EArielleProcessingType.CREATE_PROJECT_DETAILS) || lastReceivedProjectDetails) {
      !ignoreProjectDetailsFeedbackTimestamps.includes(lastReceivedProjectDetails?.timestamp!)
        && setShowAgentFeedbackProjectDetails(true);
    }
  }, [isProcessing, lastReceivedProjectRoadmap]);

  const [showAnyAgentFeedback, setShowAnyAgentFeedback] = useState(false);
  const [showAgentFeedbackRoadmap, setShowAgentFeedbackRoadmap] = useState(false);
  const [showAgentFeedbackProjectDetails, setShowAgentFeedbackProjectDetails] = useState(false);


  useEffect(() => {
    if (showAgentFeedbackRoadmap || showAgentFeedbackProjectDetails) {
      setShowAnyAgentFeedback(true);
    } else {
      setShowAnyAgentFeedback(false);
    }
  }, [showAgentFeedbackRoadmap, showAgentFeedbackProjectDetails]);

  // Handle tab title alternation for unread messages
  useEffect(() => {
    if (totalNumberUnreadMessages > 0) {
      let isDefaultTitle = true;
      const interval = setInterval(() => {
        document.title = isDefaultTitle
          ? `New Messages (${totalNumberUnreadMessages})`
          : ROUTE_TITLE_MAP[location.pathname];
        isDefaultTitle = !isDefaultTitle;
      }, 1000);

      return () => {
        clearInterval(interval);
        document.title = ROUTE_TITLE_MAP[location.pathname];
      };
    } else {
      document.title = ROUTE_TITLE_MAP[location.pathname];
    }
  }, [totalNumberUnreadMessages]);

  // use navbar as "top level" component to unselect active chat
  useEffect(() => {
    if (location.pathname !== CHAT_ROUTE) {
      unselectActiveChat();
    }
  }, [location.pathname]);

  const userLogout = () => {
    logout();
    // goToLogin();
  }


  return (

    <Disclosure as="nav" className={`${(!isLoggedIn || location.pathname === SIGNUP_UPDATE_PROFILE_ROUTE) ? 'hidden' : ''} sticky z-10 h-max max-w-full top-0 backdrop-blur-xl shadow-md 
    ${showAnyAgentFeedback ? 'pb-1 from-primary-600/70 to-primary-700/70 bg-gradient-to-b' : 'bg-white/70'} transition-all duration-500`}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 justify-between">
          <div className="flex">
            <div className="mr-2 -ml-2 flex items-center md:hidden">
              {/* Mobile menu button */}
              {isLoggedIn && <DisclosureButton className="group relative inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500  focus:outline-hidden ">
                <span className="absolute -inset-0.5" />
                <span className="sr-only">Open main menu</span>
                <RxHamburgerMenu aria-hidden="true" className="block size-6 group-data-open:hidden" />
                <HiXMark aria-hidden="true" className="hidden size-6 group-data-open:block" />
              </DisclosureButton>}
            </div>
            <div className="flex shrink-0 items-center">
              <img
                alt="Gamershome Logo"
                src={BRAND_ASSETS.LOGO_SMALL_BLACK}
                className="h-8 w-auto"
              />
            </div>

            {/* Links on Desktop */}
            <div className="hidden md:ml-6 md:flex md:space-x-8">
              {isLoggedIn && <NavbarLink
                text="Dashboard"
                onClick={goToDashboard}
                isActivePath={[DASHBOARD_ROUTE]}
                mode={showAnyAgentFeedback ? 'dark' : 'light'}
              />}
              {isLoggedIn && <NavbarLink
                text="Browse Talent"
                onClick={goToBrowseFreelancers}
                isActivePath={[BROWSE_FREELANCERS_ROUTE]}
                mode={showAnyAgentFeedback ? 'dark' : 'light'}
              />}
              {isLoggedIn && currentUserType === EUserType.FREELANCER && <NavbarLink
                text="Find Tasks"
                onClick={goToJobs}
                isActivePath={[JOBS_ROUTE]}
                mode={showAnyAgentFeedback ? 'dark' : 'light'}
              />}
              {isLoggedIn && <NavbarLink
                text="Projects"
                onClick={goToMyProjects}
                isActivePath={[PROJECTS_ROUTE, PROJECT_DETAILS_ROUTE]}
                mode={showAnyAgentFeedback ? 'dark' : 'light'}
              />}
              {isLoggedIn && currentUserType === EUserType.FREELANCER && <NavbarLink text="Task Engagements"
                onClick={goToEngagements}
                isActivePath={[ENGAGEMENTS_ROUTE]}
                mode={showAnyAgentFeedback ? 'dark' : 'light'}
              />}
            </div>
          </div>
          <div className="flex items-center">
            {/* Quick Actions */}
            <div className="shrink-0">
              {isLoggedIn && currentUserType === EUserType.EMPLOYER && <div className='flex flex-row gap-4'>
                <FilledButton
                  onClick={goToCreateNewProject}
                  icon={<FiPlus aria-hidden="true" />}
                  iconPosition='leading'
                  theme={showAnyAgentFeedback ? 'white' : 'neutral'}
                >Create Project</FilledButton>
                {wallet &&
                  <div className='flex flex-col'>
                    <p className={`text-xs ${showAnyAgentFeedback ? 'text-white' : 'text-gray-700'}`}>Wallet</p>
                    <p className={`text-sm ${showAnyAgentFeedback ? 'text-white' : 'text-gray-700'} font-bold`}>{(wallet as EmployerWallet).totalCredits - (wallet as EmployerWallet).totalOccupiedCredits} Hrs</p>
                  </div>}
              </div>}


              {isLoggedIn && currentUserType === EUserType.FREELANCER && <div className='flex flex-row gap-4'>
                {wallet &&
                  <Tooltip text={`You have ${(wallet as FreelancerWallet).credits} credits in your wallet which is worth $${Number((config?.rateCreditsToUsd.freelancer || 0) * (wallet as FreelancerWallet).credits).toFixed(2)}`}>
                    <div className='flex flex-col'>
                      <p className={`text-xs ${showAnyAgentFeedback ? 'text-white' : 'text-gray-700'}`}>Wallet</p>
                      <p className={`text-sm ${showAnyAgentFeedback ? 'text-white' : 'text-gray-700'} font-bold`}>{(wallet as FreelancerWallet).credits} Credits</p>
                    </div>
                  </Tooltip>}
              </div>}


              {!isLoggedIn && <div className='flex flex-row gap-2'>
                <OutlinedButton
                  onClick={goToLogin}
                >Login</OutlinedButton>
                <FilledButton
                  onClick={goToSignup}
                >Signup</FilledButton>
              </div>}

            </div>
            <div className="hidden md:ml-4 md:flex md:shrink-0 md:items-center">
              {/* Chat Icon */}
              {isLoggedIn && <IconButton
                theme={totalNumberUnreadMessages > 0 ? showAnyAgentFeedback ? 'white' : 'primary'
                  : showAnyAgentFeedback ? 'white' : 'black'}
                size='m'
                onClick={goToChat}
                icon={totalNumberUnreadMessages > 0
                  ? <IoChatbubbleEllipsesOutline />
                  : <IoChatbubbleOutline />
                }
              />}


              {/* Profile dropdown */}
              {isLoggedIn && <Menu as="div" className="relative ml-3">
                <div>
                  <MenuButton className="relative flex rounded-full text-sm ">
                    <span className="absolute -inset-1.5" />
                    <span className="sr-only">Open user menu</span>
                    <img
                      alt="User Avatar"
                      src={currentUser?.profilePictureUrl || (currentUserType === EUserType.EMPLOYER ? DEFAULT_USER_PROFILE.DEFAULT_EMPLOYER_PROFILE_PICTURE : DEFAULT_USER_PROFILE.DEFAULT_FREELANCER_PROFILE_PICTURE_MALE)}
                      className="size-8 rounded-full"
                    />
                  </MenuButton>
                </div>
                <MenuItems
                  transition
                  className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg  transition data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-200 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
                >
                  <MenuItem>
                    <div className='flex flex-col px-4 py-2 text-sm'>

                      <div className='text-gray-500'>Logged in as</div>
                      <div className='text-gray-700'>{currentUser?.email}</div>
                    </div>
                  </MenuItem>

                  <MenuItem>
                    <div
                      className='flex flex-row px-4 py-2 text-sm gap-2 cursor-pointer items-center hover:bg-gray-100 transition-colors duration-200'
                      onClick={() => { goToUserProfile(currentUserType!, currentUser?._id!); }}>
                      <CiUser />
                      <p className='text-sm text-gray-700 data-focus:bg-gray-100 data-focus:outline-hidden'>Your Profile</p>
                    </div>

                  </MenuItem>
                  <MenuItem>
                    <div
                      className='flex flex-row px-4 py-2 text-sm gap-2 cursor-pointer items-center hover:bg-gray-100 transition-colors duration-200'
                      onClick={userLogout}>
                      <IoMdLogOut />
                      <p className='text-sm text-gray-700 data-focus:bg-gray-100 data-focus:outline-hidden'>Sign Out</p>
                    </div>
                  </MenuItem>
                </MenuItems>
              </Menu>}
            </div>
          </div>
        </div>
      </div>

      {/* Agent Feedback */}
      <div className={`mx-auto max-w-7xl  rounded-lg overflow-hidden
        ${showAnyAgentFeedback ? 'max-h-96 py-1 px-4 sm:px-6 lg:px-8' : 'max-h-0'} transition-all duration-500`}>

        <div className={`flex flex-col gap-2 
        `}>
          {showAgentFeedbackRoadmap
            && <div className='flex flex-row w-full gap-2'>
              {renderArielleCreatingRoadmapNotification()}
              {lastReceivedProjectRoadmap && <div className='flex flex-col'>
                <TextButton onClick={() => {
                  setShowAgentFeedbackRoadmap(false);
                  setIgnoreRoadmapFeedbackTimestamps([...ignoreRoadmapFeedbackTimestamps, lastReceivedProjectRoadmap?.timestamp!]);
                }}
                  size='small'
                  theme={showAnyAgentFeedback ? 'white' : 'neutral'}>
                  Hide
                </TextButton>
                <TextButton
                  onClick={() => {
                    goToProjectDetails(lastReceivedProjectRoadmap.projectId!, EProjectDetailsNav.ROADMAP);
                    setShowAgentFeedbackRoadmap(false);
                    setIgnoreRoadmapFeedbackTimestamps([...ignoreRoadmapFeedbackTimestamps, lastReceivedProjectRoadmap?.timestamp!]);
                  }}
                  size='small'
                  theme={showAnyAgentFeedback ? 'white' : 'neutral'}>

                  Show
                </TextButton>
              </div>}
            </div>}
          {showAgentFeedbackProjectDetails
            && <div className='flex flex-row w-full gap-2'>
              {renderArielleCreatingProjectDetailsNotification()}
              {lastReceivedProjectDetails && <div className='flex flex-col'>
                <TextButton onClick={() => {
                  setShowAgentFeedbackProjectDetails(false);
                  setIgnoreProjectDetailsFeedbackTimestamps([...ignoreProjectDetailsFeedbackTimestamps, lastReceivedProjectDetails?.timestamp!]);
                }}
                  size='small'
                  theme={showAnyAgentFeedback ? 'white' : 'neutral'}>
                  Hide
                </TextButton>
                <TextButton
                  onClick={() => {
                    goToProjectDetails(lastReceivedProjectDetails!.projectId!, EProjectDetailsNav.OVERVIEW);
                    setShowAgentFeedbackProjectDetails(false);
                    setIgnoreProjectDetailsFeedbackTimestamps([...ignoreProjectDetailsFeedbackTimestamps, lastReceivedProjectDetails?.timestamp!]);
                  }}
                  size='small'
                  theme={showAnyAgentFeedback ? 'white' : 'neutral'}>

                  Show
                </TextButton>
              </div>}
            </div>}
        </div>
      </div>


      {isLoggedIn && <DisclosurePanel className="md:hidden">
        <div className="space-y-1 pt-2 pb-3">

          {isLoggedIn && <MobileMenueButton
            text="Dashboard"
            onClick={goToDashboard}
            isActivePath={[DASHBOARD_ROUTE]}
          />}
          {isLoggedIn && <MobileMenueButton
            text="Browse Talent"
            onClick={goToBrowseFreelancers}
            isActivePath={[BROWSE_FREELANCERS_ROUTE]}
          />}
          {currentUserType === EUserType.FREELANCER && <MobileMenueButton
            text="Find Tasks"
            onClick={goToJobs}
            isActivePath={[JOBS_ROUTE]}
          />}
          {isLoggedIn && <MobileMenueButton
            text="Projects"
            onClick={goToMyProjects}
            isActivePath={[PROJECTS_ROUTE, PROJECT_DETAILS_ROUTE]}
          />}
          {currentUserType === EUserType.FREELANCER && <MobileMenueButton
            text="Task Engagements"
            onClick={goToEngagements}
            isActivePath={[ENGAGEMENTS_ROUTE]}
          />}
        </div>
        <div className="border-t border-gray-200 pt-4 pb-3">
          <div className="flex items-center px-4 sm:px-6">
            <div className="shrink-0">
              <img
                alt="User Avatar"
                src={currentUser?.profilePictureUrl || (currentUserType === EUserType.EMPLOYER ? DEFAULT_USER_PROFILE.DEFAULT_EMPLOYER_PROFILE_PICTURE : DEFAULT_USER_PROFILE.DEFAULT_FREELANCER_PROFILE_PICTURE_MALE)}
                className="size-10 rounded-full"
              />
            </div>
            {isLoggedIn && <div className="ml-3">
              <div className="text-base font-medium text-gray-800">{currentUserType === EUserType.EMPLOYER ? getEmployerName(currentUser as IEmployer) : getFreelancerName(currentUser as IFreelancer)}</div>
              <div className="text-sm font-medium text-gray-500">{currentUser?.email}</div>
            </div>}
            <div className='ml-auto'>
              {isLoggedIn && <DisclosureButton><IconButton
                theme={totalNumberUnreadMessages > 0 ? 'primary' : 'black'}
                size='m'
                onClick={goToChat}
                icon={totalNumberUnreadMessages > 0
                  ? <BiMessageRoundedDots />
                  : <BiMessageRounded />
                }
              /></DisclosureButton>}
            </div>
          </div>
          <div className="mt-3 space-y-1">
            {isLoggedIn && currentUserType !== undefined && currentUser !== null && <MobileMenuButton
              text="Your Profile"
              onClick={() => {
                goToUserProfile(currentUserType!, currentUser?._id!);
              }}
            />}
            <MobileMenuButton
              text="Sign out"
              onClick={userLogout}
            />
          </div>
        </div>
      </DisclosurePanel>}
    </Disclosure>

  );
};


export default Navbar;
